import React, { ReactElement } from 'react'
import { TopNavigationSubProps } from '@/components/layout/TopNavigation/TopNavigation.types'

export const TopNavigationLoggedOut: React.FC<
    TopNavigationSubProps
> = (): ReactElement => {
    return <div />
}
